import React from 'react'
import { Switch, SwitchProps, Flex, Typography } from 'antd'
import { CheckOutlined, CloseOutlined } from '@ant-design/icons'
import { FieldError } from 'react-hook-form'
import ErrorText from 'src/app/shared/components/common/error-text'

const CustomSwitch: React.FC<
  SwitchProps & {
    label?: string
    required?: boolean
    error?: FieldError
    containerStyle?: React.CSSProperties
  }
> = (props) => {
  const { label, required, error, style, containerStyle, ...etc } = props

  return (
    <div
      className='custom-input'
      style={{
        flex: 1,
        ...containerStyle,
      }}
    >
      <Flex
        style={{
          gap: 8,
          alignItems: 'center',
        }}
      >
        <Switch
          style={{
            ...style,
          }}
          {...etc}
          checkedChildren={<CheckOutlined />}
          unCheckedChildren={<CloseOutlined />}
        />
        <Typography.Text
          style={{ textAlign: 'left', fontSize: '14px' }}
          className={`${required ? 'required' : ''} custom-select-label`}
        >
          {label}
        </Typography.Text>
      </Flex>
      {error && <ErrorText>{error.message}</ErrorText>}
    </div>
  )
}

export default CustomSwitch
